import { render, staticRenderFns } from "./InventoryItemView.vue?vue&type=template&id=6a76cfa0&scoped=true"
import script from "./InventoryItemView.vue?vue&type=script&lang=js"
export * from "./InventoryItemView.vue?vue&type=script&lang=js"
import style0 from "./InventoryItemView.vue?vue&type=style&index=0&id=6a76cfa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76cfa0",
  null
  
)

export default component.exports